import { create } from "zustand";

interface ControlPanelState {
  open: boolean;
  openControl: () => void;
  close: () => void;
}

/**
 * Global state for the ControlPanel overlay.
 *
 * Сейчас панель — admin-only с единственной вкладкой «Пользователи»,
 * поэтому tab-state не нужен. Стор остался ради `open`-флага: панель
 * — full-screen takeover, открываемый из любого места дерева.
 */
export const useControlPanelStore = create<ControlPanelState>((set) => ({
  open: false,
  openControl: () => set({ open: true }),
  close: () => set({ open: false }),
}));
